// ─── Period ───────────────────────────────────────────────────────────────────
// In produzione il `period` è una stringa nel formato "MM/YYYY" (es. "04/2025").
// Verificato in Fase 0 sui dati reali (Credits/Debits/PaymentReceipts al 100% MM/YYYY).
// NON usare "YYYYMM". Le label leggibili dei mesi sono gestite via i18n nel frontend.
const PERIOD_RE = /^(0[1-9]|1[0-2])\/\d{4}$/;
/** Periodo corrente nel formato "MM/YYYY". */
export function currentPeriod(date = new Date()) {
    return makePeriod(date.getMonth() + 1, date.getFullYear());
}
/** Costruisce un periodo "MM/YYYY" da mese (1-12) e anno. */
export function makePeriod(month, year) {
    return `${String(month).padStart(2, "0")}/${year}`;
}
/** True se la stringa è un periodo valido "MM/YYYY". */
export function isValidPeriod(period) {
    return PERIOD_RE.test(period);
}
/** Mese (1-12) di un periodo "MM/YYYY". */
export function periodMonth(period) {
    return Number(period.slice(0, 2));
}
/** Anno di un periodo "MM/YYYY". */
export function periodYear(period) {
    return Number(period.split("/")[1]);
}
//# sourceMappingURL=period.js.map